<footer class="footer">
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-12">
                <div class="copyright justify-content-center align-item-center w-inherit text-center">
                    NEIBA Technologies &copy; {{ date | date : "yyyy" }} — Tous droits réservés
                </div>
            </div>
        </div>

    </div>
</footer>
